var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKassa24White(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 55,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "kassa24") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 602,
    width: 802,
    y: -1,
    x: -1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    id: "svg_1",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_3",
    fill: "#FFCC05",
    d: "m5.79,8.657c-4.768,0 -7.493,5.602 -4.598,9.337l27.08,34.63c2.385,3.055 6.984,3.055 9.198,0l27.08,-34.63c3.067,-3.735 0.34,-9.337 -4.598,-9.337l-54.16,0l-0.002,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_4",
    fill: "#231F20",
    d: "m5.45,23.426c3.236,-12.053 14.307,-20.88 27.422,-20.88c13.284,0 24.185,8.827 27.42,20.88l2.045,-2.377c-4.087,-12.224 -15.84,-21.049 -29.465,-21.049c-13.626,0 -25.208,8.827 -29.295,21.05l1.873,2.376z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_5",
    fill: "#FFF229",
    d: "m28.273,52.623c2.384,3.056 6.983,3.056 9.197,0l22.823,-29.197c-3.236,-12.053 -14.137,-20.88 -27.42,-20.88c-13.116,0 -24.187,8.827 -27.423,20.88l22.823,29.197z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_6",
    d: "m42.07,24.275l0,4.244l-6.644,0l0,14.596l-4.94,0l0,-14.595l-6.812,0l0,-4.245l18.396,0zm0,-2.037l-18.397,0l0,-4.244l18.397,0l0,4.244z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_7",
    fill: "#231F20",
    d: "m8.175,26.99c1.875,-11.88 12.263,-21.05 24.697,-21.05c12.603,0 22.993,9.168 24.696,21.05l1.533,-1.867c-2.553,-11.883 -13.283,-20.88 -26.227,-20.88c-12.774,0 -23.504,8.998 -26.06,20.88l1.363,1.868l-0.002,-0.001z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKassa24White);
export default __webpack_public_path__ + "static/media/kassa24-white.93e4a76f68dff1566bb94bc2673a81b8.svg";
export { ForwardRef as ReactComponent };